import { render, staticRenderFns } from "./PrintArchivedDocument.vue?vue&type=template&id=031967bb&scoped=true&"
import script from "./PrintArchivedDocument.vue?vue&type=script&lang=js&"
export * from "./PrintArchivedDocument.vue?vue&type=script&lang=js&"
import style0 from "./PrintArchivedDocument.vue?vue&type=style&index=0&id=031967bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031967bb",
  null
  
)

export default component.exports